// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-pages-index-tsx": () => import("./../../../src/templates/pages/index.tsx" /* webpackChunkName: "component---src-templates-pages-index-tsx" */)
}

